import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import Login from './pages/Login';
import Register from './pages/Register';
import PendingOrders from './pages/PendingOrders';
import ProcessingOrders from './pages/ProcessingOrders';
import CompletedOrders from './pages/CompletedOrders';
import UrgentOrders from './pages/UrgentOrders';
import StrategyAnalysis from './pages/StrategyAnalysis';
import Translation from './pages/Translation';
import PricingStrategy from './pages/PricingStrategy';
import Dashboard from './pages/Dashboard';
import InboxEmails from './pages/InboxEmails';
import KewellOrders from './pages/KewellOrders';
import MyAllOrders from './pages/MyAllOrders';
import PriorityRules from './pages/PriorityRules';
import Customers from './pages/Customers';
import AppealList from './pages/AppealList';
import ClaimList from './pages/ClaimList';
import RebillList from './pages/RebillList';
import DummyCatchAll from './pages/DummyCatchAll';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/" element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="orders/pending" element={<PendingOrders />} />
        <Route path="orders/processing" element={<ProcessingOrders />} />
        <Route path="orders/urgent" element={<UrgentOrders />} />
        <Route path="orders/completed" element={<CompletedOrders />} />
        <Route path="kewell-orders" element={<KewellOrders />} />
        <Route path="orders/all" element={<MyAllOrders />} />
        <Route path="emails/inbox" element={<InboxEmails />} />
        <Route path="priority" element={<PriorityRules />} />
        <Route path="customers" element={<Customers />} />
        {/* 每条状态路由使用独立 key：切换二级路由时强制重挂载，避免复用同一组件实例导致列表状态不刷新 */}
        <Route path="appeals/pending" element={<AppealList key="appeals-pending" defaultStatus="pending" title="申诉待跟进工单" desc="客服/销售/调度生成的申诉工单先进入本列表，由申诉处理人跟进，填写处理思路后流转到申诉处理中工单" />} />
        <Route path="appeals/processing" element={<AppealList key="appeals-processing" defaultStatus="processing" title="申诉处理中工单" desc="申诉已填写处理思路并实操跟进的工单；邮件匹配后流转至待客服处理，由客服/销售查看回复" />} />
        <Route path="appeals/awaiting-customer" element={<AppealList key="appeals-awaiting" defaultStatus="awaiting_customer" title="申诉待客服处理工单" desc="申诉处理中已填写处理结果并流转给客服的工单，由客服/销售查看并回复后回到申诉待跟进" />} />
        <Route path="appeals/urgent" element={<AppealList key="appeals-urgent" defaultStatus="urgent" title="申诉紧急工单" desc="紧急重要的申诉工单，优先跟进" />} />
        <Route path="appeals/completed" element={<AppealList key="appeals-completed" defaultStatus="completed" title="申诉完成" desc="申诉处理完成的工单，可重新打开继续跟进" />} />
        <Route path="claims/pending" element={<ClaimList key="claims-pending" defaultStatus="pending" title="索赔待跟进工单" desc="客服/销售/调度生成的索赔工单先进入本列表，由索赔处理人跟进，填写处理思路后流转到索赔处理中工单" />} />
        <Route path="claims/processing" element={<ClaimList key="claims-processing" defaultStatus="processing" title="索赔处理中工单" desc="索赔已填写处理思路并实操跟进的工单；邮件匹配后流转至待客服处理，由客服/销售查看回复" />} />
        <Route path="claims/awaiting-customer" element={<ClaimList key="claims-awaiting" defaultStatus="awaiting_customer" title="索赔待客服处理工单" desc="索赔处理中已填写处理结果并流转给客服的工单，由客服/销售查看并回复后回到索赔待跟进" />} />
        <Route path="claims/urgent" element={<ClaimList key="claims-urgent" defaultStatus="urgent" title="索赔紧急工单" desc="紧急重要的索赔工单，优先跟进" />} />
        <Route path="claims/completed" element={<ClaimList key="claims-completed" defaultStatus="completed" title="索赔完成" desc="索赔处理完成的工单，可重新打开继续跟进" />} />
        <Route path="strategy" element={<StrategyAnalysis />} />
        <Route path="translation" element={<Translation />} />
        <Route path="pricing" element={<PricingStrategy />} />
        <Route path="rebills" element={<RebillList />} />
        <Route path="orders/*" element={<DummyCatchAll />}>
          <Route path="detail/:id" element={<DummyCatchAll />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
